export const de = {
  app: {
    title: "Reno-Budget",
    subtitle: "Renovations- und Unterhaltskosten für Liegenschaften",
    version: "Version",
  },
  auth: {
    login: {
      title: "Anmelden",
      email: "E-Mail",
      password: "Passwort",
      submit: "Anmelden",
      forgot: "Passwort vergessen?",
      errorGeneric: "Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.",
      errorLocked: "Konto vorübergehend gesperrt. Bitte später erneut versuchen.",
      errorInactive: "Konto deaktiviert. Bitte Administrator kontaktieren.",
      errorRateLimited: "Zu viele Versuche. Bitte kurz warten und erneut versuchen.",
    },
    logout: "Abmelden",
    invite: {
      title: "Einladung annehmen",
      displayName: "Name",
      password: "Passwort wählen",
      passwordHint: "Mindestens 12 Zeichen; Kombination aus Buchstaben, Ziffern und Sonderzeichen.",
      submit: "Konto erstellen",
      errorInvalid: "Einladungslink ist ungültig oder abgelaufen.",
      errorConflict: "Diese E-Mail ist bereits registriert.",
    },
    reset: {
      requestTitle: "Passwort zurücksetzen",
      requestSubmit: "Link anfordern",
      requestSent:
        "Wenn die E-Mail-Adresse bei uns registriert ist, erhalten Sie in Kürze einen Link.",
      confirmTitle: "Neues Passwort vergeben",
      newPassword: "Neues Passwort",
      confirmSubmit: "Passwort speichern",
      confirmSuccess: "Passwort gespeichert. Sie können sich nun anmelden.",
      errorInvalid: "Reset-Link ist ungültig, abgelaufen oder bereits verwendet.",
    },
    me: {
      greeting: "Angemeldet als {{name}}",
    },
  },
  common: {
    loading: "Wird geladen…",
    error: "Es ist ein Fehler aufgetreten.",
    submitting: "Wird gesendet…",
    close: "Schliessen",
  },
  nav: {
    home: "Start",
    objects: "Objekte",
    projektsListe: "Projekte",
    lotsListe: "Lose",
    suppliersListe: "Lieferanten",
    finances: "Finanzen",
    overviews: "Übersichten",
    adminAudit: "Admin · Audit",
    back: "Zurück",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schliessen",
    userMenu: "Benutzermenü",
    language: "Sprache",
    currentObject: "Aktuelles Objekt",
    crumb: {
      home: "Start",
      objects: "Objekte",
      newObject: "Neues Objekt",
      costs: "Kosten",
      budget: "Budget",
      renofond: "Renofond",
      audit: "Audit",
      finances: "Finanzen",
      admin: "Admin",
      adminAudit: "Audit-Protokoll",
      projects: "Projekte",
      lots: "Lose",
      suppliers: "Lieferanten",
      projektsListe: "Projekte (alle)",
      lotsListe: "Lose (alle)",
      suppliersListe: "Lieferanten (alle)",
    },
  },
  objects: {
    list: {
      title: "Objekte",
      create: "Neues Objekt",
      empty: "Noch keine Objekte. Legen Sie Ihr erstes Objekt an.",
    },
    create: {
      title: "Objekt erstellen",
      submit: "Objekt anlegen",
    },
    fields: {
      name: "Bezeichnung",
      address: "Adresse",
      yearBuilt: "Baujahr",
      type: "Typ",
    },
    type: {
      sfh: "Einfamilienhaus",
      mfh: "Mehrfamilienhaus / Stockwerkeigentum",
    },
    units: {
      title: "Einheiten",
      label: "Bezeichnung",
      wertquote: "Wertquote",
      area: "Fläche",
      add: "Einheit hinzufügen",
      remove: "Entfernen",
      implicitLabel: "Ganzes Haus",
      sum: "Summe: {{sum}}‰",
      sumHint: "muss 1000‰ ergeben",
    },
    detail: {
      tabUnits: "Einheiten",
      tabCosts: "Kosten",
    },
    apiTokens: {
      title: "API-Zugänge",
      intro:
        "Zugänge für andere Programme (z. B. den Ferienhaus-Manager). Ein Zugang handelt in Ihrem Namen, gilt nur für die Kostenpositionen dieses Objekts und kann jederzeit widerrufen werden.",
      create: "Neuer Zugang",
      submit: "Zugang erstellen",
      cancel: "Abbrechen",
      name: "Bezeichnung",
      hint: "Kennung",
      scopes: "Berechtigungen",
      scope: {
        read: "Kostenpositionen lesen",
        write: "Kostenpositionen anlegen und ändern",
      },
      lastUsed: "Zuletzt benutzt",
      empty: "Noch keine API-Zugänge.",
      onceTitle: "Neuer Zugang erstellt",
      onceHint:
        "Dieser Schlüssel wird nur jetzt angezeigt. Kopieren Sie ihn und hinterlegen Sie ihn im anderen Programm.",
      copy: "Kopieren",
      copied: "Kopiert",
      done: "Fertig",
      revoke: "Widerrufen",
      revokeConfirm: "Zugang «{{name}}» widerrufen? Programme, die ihn nutzen, verlieren sofort den Zugriff.",
    },
  },
  costs: {
    title: "Kostenpositionen",
    create: "Neue Kostenposition",
    edit: "Kostenposition bearbeiten",
    empty: "Noch keine Kostenpositionen erfasst.",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    deleteConfirm: "Kostenposition wirklich löschen?",
    tabs: {
      list: "Liste",
      board: "Board",
    },
    fields: {
      title: "Titel",
      description: "Beschreibung",
      bkp: "BKP",
      npk: "NPK",
      status: "Status",
      priority: "Priorität",
      plannedYear: "Geplant (Jahr)",
      plannedYearInherited: "Jahr vom Projekt übernommen",
      plannedAmount: "Geplant CHF",
      actualAmount: "Effektiv CHF",
      actualDate: "Ausführungsdatum",
      lifespanYears: "Lebensdauer (Jahre)",
      warrantyUntil: "Garantie bis",
      scope: "Geltungsbereich",
      allocations: "Zuteilungen",
    },
    status: {
      idea: "Idee",
      planned: "Geplant",
      in_progress: "In Arbeit",
      completed: "Abgeschlossen",
      cancelled: "Storniert",
    },
    priority: {
      low: "Niedrig",
      med: "Mittel",
      high: "Hoch",
      urgent: "Dringend",
    },
    scope: {
      shared: "Gemeinsam",
      unit: "Pro Einheit",
    },
    filters: {
      title: "Filter",
      status: "Status",
      priority: "Priorität",
      plannedYear: "Geplantes Jahr",
      unit: "Einheit",
      bkpPrefix: "BKP-Gruppe",
      search: "Titel suchen",
      reset: "Zurücksetzen",
      anyUnit: "Alle Einheiten",
      anyBkp: "Alle BKP",
      project: "Projekt",
      anyProject: "Alle Projekte",
      lot: "Los",
      anyLot: "Alle Lose",
      tags: "Tags",
    },
    bkp: {
      pickerTitle: "BKP-Code wählen",
      search: "Code oder Bezeichnung suchen",
      empty: "Keine Treffer",
      none: "Kein Code gewählt",
      loading: "Katalog wird geladen…",
    },
    uncategorised: "Ohne BKP",
    inLots: "in {{count}} Los",
    inLots_other: "in {{count}} Losen",
    inLotsTitle: "Anzahl Lose, in denen diese Position enthalten ist",
    bkpAllocations: {
      title: "BKP-Aufteilung (mehrere Codes)",
      toggle: "Detaillierte BKP-Aufteilung",
      toggleHint:
        "Wenn aktiv, wird statt eines einzelnen BKP-Codes ein Betrag prozentual auf mehrere Codes verteilt.",
      empty: "Noch keine Aufteilung. Code hinzufügen.",
      add: "Code hinzufügen",
      remove: "Entfernen",
      chooseCode: "Code wählen…",
      codeColumn: "BKP-Code",
      shareColumn: "Anteil ‰",
      sum: "Summe: {{sum}}‰",
      sumHint: "muss 1000‰ ergeben",
    },
    project: "Projekt",
    projectNone: "Kein Projekt",
    tags: "Tags",
    tagAssignPartial:
      "Kostenposition gespeichert, aber {{count}} Tag(s) konnten nicht zugewiesen werden. Bitte im Detail erneut versuchen.",
    allocations: {
      sum: "Summe: {{sum}}‰",
      sumHint: "muss 1000‰ ergeben",
      add: "Einheit hinzufügen",
      remove: "Entfernen",
      reset: "Standard (Wertquote)",
      resetHint: "Verteilt nach Wertquoten der Einheiten",
      emptyShared: "Keine Einheiten verfügbar.",
      emptyUnit: "Noch keine Zuteilung. Einheit auswählen.",
      unitColumn: "Einheit",
      shareColumn: "Anteil ‰",
      chooseUnit: "Einheit wählen…",
    },
    errors: {
      titleRequired: "Titel erforderlich",
      bkpRequired: "BKP-Code erforderlich",
      amountRequired: "Mindestens ein Betrag (geplant oder effektiv) erforderlich",
      allocationsRequired: "Für 'Pro Einheit' ist mindestens eine Zuteilung erforderlich",
      allocationsSum: "Summe der Anteile muss 1000‰ ergeben (aktuell {{sum}}‰)",
    },
  },
  budget: {
    tab: "Budget",
    nav: "Finanzen",
    title: "Budget & Reserve",
    inflationToggle: {
      label: "Darstellung",
      nominal: "Nominal",
      inflated: "Inflationsbereinigt",
    },
    timeline: {
      title: "Zeitachse",
      planned: "Geplant",
      actual: "Effektiv",
      year: "Jahr",
      noData: "Keine Daten vorhanden.",
      drillTitle: "Positionen {{year}}",
      drillClose: "Schliessen",
      drillEmpty: "Keine Positionen in diesem Jahr.",
    },
    bkpGroup: {
      title: "Nach eBKP-H Hauptgruppe",
      group: "Gruppe",
      amount: "Betrag",
      empty: "Keine Daten.",
      uncategorised: "Ohne BKP",
    },
    unit: {
      title: "Nach Einheit",
      unit: "Einheit",
      planned: "Geplant",
      actual: "Effektiv",
      empty: "Keine Einheiten.",
    },
    statusPriority: {
      title: "Status & Priorität",
      status: "Status",
      priority: "Priorität",
      empty: "Keine Daten.",
    },
    reserve: {
      title: "Reserve-Planung",
      totalPlanned: "Geplantes Total (inflationsbereinigt)",
      initialReserve: "Anfangsreserve",
      requiredTotal: "Benötigtes Total",
      requiredContribution: "Erforderliche Einlage",
      modeLabel: "Beitragsmodus",
      modes: {
        monthly: "Monatlich",
        yearly: "Jährlich",
        lump_sum: "Einmalbetrag pro Jahr",
      },
      formula: {
        monthly: "CHF pro Monat",
        yearly: "CHF pro Jahr",
        lump_sum: "Einzahlungen nach Jahr",
      },
      inflationRate: "Inflationsrate (% p.a.)",
      save: "Speichern",
      saving: "Wird gespeichert…",
      saved: "Gespeichert.",
      readOnlyHint: "Nur Eigentümer können diese Werte bearbeiten.",
      lumpSumYear: "Jahr",
      lumpSumAmount: "CHF",
    },
    finances: {
      title: "Finanzen — Übersicht",
      subtitle: "Alle Objekte und deren Reserve-Bedarf",
      object: "Objekt",
      role: "Rolle",
      plannedTotal: "Geplant (infl.)",
      actualTotal: "Effektiv",
      requiredPerYear: "Pro Jahr benötigt",
      scopedBadge: "anteilig",
      empty: "Keine Objekte verfügbar.",
      roles: {
        owner: "Eigentümer",
        editor: "Bearbeiter",
        viewer: "Betrachter",
      },
    },
    errors: {
      forbidden: "Keine Berechtigung, diese Daten einzusehen.",
      generic: "Budgetdaten konnten nicht geladen werden.",
    },
  },
  renofond: {
    tab: "Renofond",
    title: "Renofond — Projektion",
    subtitle: "Reserveverlauf über den Planungshorizont",
    backToBudget: "Zurück zum Budget",
    projection: {
      title: "Bilanzverlauf",
      year: "Jahr",
      required: "Soll-Beitrag",
      actual: "Effektive Einzahlung",
      plannedSpend: "Geplanter Aufwand",
      balance: "Saldo Ende Jahr",
      cumulative: "Kumulierter Plan",
      noData: "Keine Projektionsdaten vorhanden.",
      legendBalance: "Saldo",
      legendPlanned: "Plan",
    },
    underfunding: {
      banner: "Unterdeckung in den folgenden Jahren erkannt:",
      year: "Jahr",
      shortfall: "Fehlbetrag",
    },
    contributions: {
      title: "Effektive Einzahlungen",
      year: "Jahr",
      amount: "Betrag CHF",
      note: "Notiz",
      created: "Erfasst am",
      actions: "Aktionen",
      add: "Einzahlung erfassen",
      delete: "Löschen",
      empty: "Noch keine Einzahlungen erfasst.",
      readOnlyHint: "Nur Eigentümer können Einzahlungen erfassen oder löschen.",
      submit: "Speichern",
      submitting: "Wird gespeichert…",
      saved: "Gespeichert.",
    },
    errors: {
      forbidden: "Keine Berechtigung, diese Daten einzusehen.",
      generic: "Daten konnten nicht geladen werden.",
      invalidAmount: "Ungültiger Betrag.",
      invalidYear: "Ungültiges Jahr.",
    },
  },
  audit: {
    tab: "Verlauf",
    title: "Verlauf — Aktivitäten",
    subtitle: "Wer hat wann was geändert?",
    globalTitle: "Globales Audit-Log",
    globalLink: "Audit-Log",
    columns: {
      time: "Zeit",
      actor: "Benutzer",
      action: "Aktion",
      summary: "Beschreibung",
    },
    loadMore: "Weitere laden",
    empty: "Noch keine Einträge.",
    forbidden: "Nur Eigentümer können den Verlauf einsehen.",
    loadFailed: "Verlauf konnte nicht geladen werden.",
    actions: {
      "auth.login": "Anmeldung",
      "auth.password_reset_request": "Passwort-Reset angefordert",
      "auth.password_reset_confirm": "Passwort zurückgesetzt",
      "auth.invitation_accept": "Einladung angenommen",
      "object.create": "Objekt erstellt",
      "object.update": "Objekt aktualisiert",
      "object.delete": "Objekt gelöscht",
      "object.units_replace": "Einheiten ersetzt",
      "membership.grant": "Mitgliedschaft gewährt",
      "membership.update": "Mitgliedschaft aktualisiert",
      "membership.revoke": "Mitgliedschaft entfernt",
      "cost_item.create": "Kostenposition erstellt",
      "cost_item.update": "Kostenposition aktualisiert",
      "cost_item.delete": "Kostenposition gelöscht",
      "attachment.upload": "Anhang hochgeladen",
      "attachment.delete": "Anhang gelöscht",
      "reserve_contribution.create": "Einzahlung erfasst",
      "reserve_contribution.delete": "Einzahlung gelöscht",
      "bkp_code.create": "eBKP-H Code angelegt",
      "supplier.create": "Lieferant angelegt",
      "supplier.update": "Lieferant aktualisiert",
      "supplier.archive": "Lieferant archiviert",
      "supplier.delete": "Lieferant gelöscht",
      "quote.create": "Angebot erfasst",
      "quote.update": "Angebot aktualisiert",
      "quote.delete": "Angebot gelöscht",
      "quote.award": "Angebot vergeben",
    },
  },
  export: {
    label: "Export",
    xlsx: "Excel (XLSX)",
    pdf: "PDF",
    npk: "NPK-Stub (JSON)",
    failed: "Export fehlgeschlagen.",
  },
  projects: {
    title: "Projekte",
    subtitle: "Gruppen von Kostenpositionen pro Objekt",
    allTitle: "Alle Projekte",
    allSubtitle: "Alle Projekte über alle Objekte",
    create: "Neues Projekt",
    edit: "Projekt bearbeiten",
    empty: "Noch keine Projekte erfasst.",
    emptyInObject:
      "Noch keine Projekte. Lege ein Projekt an, um mit der Planung zu starten.",
    createHint: "Projekte werden im jeweiligen Objekt angelegt:",
    includeArchived: "Archivierte anzeigen",
    filter: {
      all: "Alle",
    },
    archived: "Archiviert",
    archive: "Archivieren",
    archiveConfirm: "Projekt wirklich archivieren?",
    delete: "Löschen",
    deleteConfirm: "Projekt wirklich löschen? Cost-Items werden nicht gelöscht.",
    backToList: "Zurück zur Übersicht",
    fields: {
      name: "Name",
      description: "Beschreibung",
      status: "Status",
      plannedYear: "Geplantes Jahr",
      itemCount: "Positionen",
      archivedAt: "Archiviert",
      object: "Objekt",
      roughEstimate: "Grobschätzung (CHF)",
      roughEstimatePlaceholder: "z.B. 50000",
      updatedAt: "Aktualisiert",
    },
    status: {
      idea: "Idee",
      planned: "Geplant",
      in_progress: "In Arbeit",
      completed: "Abgeschlossen",
      cancelled: "Storniert",
    },
    costItems: {
      title: "Kostenpositionen in diesem Projekt",
      empty:
        "Noch keine Positionen. Beginnen Sie mit \"Neue Position\" oder verknüpfen Sie bestehende.",
      add: "Neue Position",
      link: "Bestehende Position verknüpfen",
      remove: "Von Projekt entfernen",
      removeConfirm: "Position aus diesem Projekt entfernen?",
      linkDialog: {
        title: "Bestehende Positionen verknüpfen",
        empty: "Keine unverknüpften Positionen auf diesem Objekt.",
        search: "Titel suchen…",
        confirm: "Verknüpfen",
        cancel: "Abbrechen",
        selected: "{{count}} ausgewählt",
      },
    },
    budget: {
      heading: "Budget",
      estimate: "Grobschätzung",
      planned: "Geplant aus Positionen",
      diff: "Differenz",
      addEstimate: "Grobschätzung hinzufügen",
      edit: "Bearbeiten",
      save: "Speichern",
      cancel: "Abbrechen",
      noEstimate: "Keine Grobschätzung erfasst",
      percentOfEstimate: "{{percent}} % der Grobschätzung",
    },
    details: {
      heading: "Details",
      show: "Details anzeigen",
      hide: "Details ausblenden",
    },
    supplierExport: {
      label: "Lieferanten-Anfrage",
      pdf: "Preisanfrage (PDF)",
      json: "Positionen (JSON)",
      failed: "Lieferanten-Anfrage fehlgeschlagen.",
    },
  },
  lots: {
    title: "Lose",
    subtitle: "Ausschreibungspakete pro Objekt — projektübergreifend",
    allTitle: "Alle Lose",
    allSubtitle: "Alle Lose über alle Objekte",
    create: "Neues Los",
    edit: "Los bearbeiten",
    empty: "Noch keine Lose erfasst.",
    includeArchived: "Archivierte anzeigen",
    archived: "Archiviert",
    archive: "Archivieren",
    archiveConfirm: "Los wirklich archivieren?",
    delete: "Löschen",
    deleteConfirm:
      "Los wirklich löschen? Kostenpositionen bleiben erhalten.",
    backToList: "Zurück zur Übersicht",
    removeMemberConfirm: "Position aus diesem Los entfernen?",
    fields: {
      name: "Name",
      description: "Beschreibung",
      status: "Status",
      tenderDeadline: "Eingabetermin",
      itemCount: "Positionen",
      archivedAt: "Archiviert",
      object: "Objekt",
    },
    status: {
      draft: "Entwurf",
      tendering: "In Ausschreibung",
      awarded: "Vergeben",
      cancelled: "Storniert",
      completed: "Abgeschlossen",
    },
    members: {
      title: "Enthaltene Kostenpositionen",
      empty: "Diesem Los sind noch keine Positionen zugeordnet.",
      total: "Summe geplant",
      add: "Position hinzufügen",
      addThis: "Hinzufügen",
      remove: "Entfernen",
      noCandidates: "Keine weiteren Positionen verfügbar.",
    },
  },
  suppliers: {
    title: "Lieferanten",
    subtitle: "Adressbuch pro Objekt — Lieferanten und Handwerker",
    allTitle: "Alle Lieferanten",
    allSubtitle: "Alle Lieferanten über alle Objekte",
    create: "Neuer Lieferant",
    edit: "Lieferant bearbeiten",
    empty: "Noch keine Lieferanten erfasst.",
    includeArchived: "Archivierte anzeigen",
    archived: "Archiviert",
    archive: "Archivieren",
    archiveConfirm: "Lieferant wirklich archivieren?",
    delete: "Löschen",
    deleteConfirm:
      "Lieferant wirklich löschen? Angebote werden den Löschvorgang blockieren.",
    backToList: "Zurück zur Übersicht",
    fields: {
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      address: "Adresse",
      notes: "Notizen",
      archivedAt: "Archiviert",
      object: "Objekt",
    },
  },
  quotes: {
    title: "Angebote",
    add: "Angebot erfassen",
    empty: "Noch keine Angebote erfasst.",
    award: "Vergeben",
    awardConfirm: "Dieses Angebot als vergeben markieren?",
    awardedLabel: "Vergeben",
    fields: {
      supplier: "Lieferant",
      amount: "Betrag (CHF)",
      receivedAt: "Eingangsdatum",
      validUntil: "Gültig bis",
      status: "Status",
      notes: "Notizen",
    },
    status: {
      received: "Eingegangen",
      shortlisted: "Engere Auswahl",
      rejected: "Abgelehnt",
      awarded: "Vergeben",
    },
  },
  tags: {
    title: "Tags",
    picker: {
      label: "Tags",
      placeholder: "Tag suchen oder „schlüssel:wert“ tippen…",
      create: "Neuen Tag anlegen: {{key}}:{{value}}",
      hint: "Tipp: tippe „schlüssel:wert“, um einen neuen Tag anzulegen.",
    },
  },
  ai: {
    open: "KI-Assistent",
    title: "KI-Assistent",
    intro:
      "Der Assistent hilft dir, dieses Projekt zu beschreiben, grob zu schätzen und in BKP-Positionen zu gliedern. Alle Vorschläge sind Entwürfe — nichts wird ohne deine Bestätigung übernommen.",
    disabled: "Der KI-Assistent ist nicht konfiguriert.",
    error: "Der KI-Assistent ist auf einen Fehler gestossen.",
    running: "Wird verarbeitet…",
    rerun: "Erneut ausführen",
    needsType: "Bitte zuerst den Projekttyp bestimmen.",
    steps: {
      classify: "Projekttyp",
      question: "Fragen",
      describe: "Beschreibung",
      estimate: "Grobschätzung",
      bkp_scope: "BKP-Positionen",
    },
    stepAction: {
      classify: "Projekttyp bestimmen",
      question: "Fragen generieren",
      describe: "Beschreibung erstellen",
      estimate: "Schätzung erstellen",
      bkp_scope: "BKP-Positionen erstellen",
    },
    question: {
      choose: "Bitte wählen…",
      yes: "Ja",
      save: "Antworten speichern",
      saved: "Antworten gespeichert.",
    },
    classify: {
      result: "Erkannter Projekttyp: {{type}}",
    },
    describe: {
      heading: "Vorgeschlagene Beschreibung",
    },
    estimate: {
      heading: "Grobschätzung",
      total: "Gesamt",
      assumptions: "Annahmen",
      disclaimer:
        "Grobe Planungswerte für die Schweiz — keine Offerte. Vor Übernahme prüfen.",
    },
    bkp: {
      heading: "Vorgeschlagene BKP-Positionen",
      inScope: "Im Umfang",
      outOfScope: "Nicht im Umfang",
    },
    confidence: {
      low: "niedrige Konfidenz",
      medium: "mittlere Konfidenz",
      high: "hohe Konfidenz",
    },
    validation: {
      ok: "Keine Beanstandungen.",
      heading: "Hinweise zur Prüfung",
      critic: "Zweitmeinung (KI)",
    },
    accept: "Übernehmen",
    accepted: "Übernommen",
    acceptBlocked: "Entwurf hat Fehler und kann nicht übernommen werden.",
  },
  attachments: {
    title: "Anhänge",
    pick: "Datei wählen",
    dropzone: "Datei in dieses Feld ziehen oder unten anklicken.",
    dropHint: 'Datei hierhin ziehen oder „Datei wählen“ anklicken.',
    uploading: "Wird hochgeladen…",
    empty: "Noch keine Anhänge.",
    confirmDelete: "Wirklich löschen?",
    delete: "Löschen",
    cancel: "Abbrechen",
    errors: {
      loadFailed: "Anhänge konnten nicht geladen werden.",
      notAuthenticated: "Nicht angemeldet.",
      tooLarge: 'Datei „{{name}}“ ist zu gross (max. 25 MiB).',
      uploadFailed: "Upload fehlgeschlagen.",
      deleteFailed: "Löschen fehlgeschlagen.",
    },
  },
} as const;

export type TranslationKeys = typeof de;
